export const iconFontAwesomeAnimalsHorse = (
	<i className="fa-solid fa-horse"></i>
);
